<template>
  <div class="cart_list">
    <div class="cart_listinfo">
      <div class="row justify-content-between title-row align-items-center">
        <div class="col-7">
          <h3 class="white_space">
            {{ product.title }}
          </h3>
        </div>
        <div v-if="isEdit" class="col-auto cart-feature">
          <div class="discount">
            <a @click="callBonusAndDiscount" v-if="product.price > 0">
              點數/折價劵折抵
            </a>
          </div>
          <div class="cartlist_del">
            <img :src="require('@/assets/images/icon/trash.svg')" />
            <a href="javascript:;" @click="removeCartItem(index)">移除</a>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-9 ">
          <div class="row info-area">
            <div class="col-sm-6">
              <div class="row">
                <div class="col-auto">
                  <img :src="require('@/assets/images/icon/home.svg')" />
                  <h5>主辦單位</h5>
                </div>
                <div class="col col-sm-12 col-lg">
                  <p>{{ product.organizer }}</p>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="row">
                <div class="col-auto">
                  <img :src="require('@/assets/images/icon/map_small.svg')" />
                  <h5>開課店別</h5>
                </div>
                <div class="col col-sm-12 col-lg">
                  <p>{{ product.address }}</p>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="row">
                <div class="col-auto">
                  <img :src="require('@/assets/images/icon/time_small.svg')" />
                  <h5>開課日期</h5>
                </div>
                <div class="col col-sm-12 col-lg">
                  <p>{{ product.date }} {{ product.time }}</p>
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="row">
                <div class="col-auto">
                  <img :src="require('@/assets/images/icon/man_small.svg')" />
                  <h5>報名人數</h5>
                </div>
                <div class="col col-sm-12 col-lg">
                  <p>{{ product.quantity }}人</p>
                </div>
              </div>
            </div>

            <div v-if="isEdit" class="col-12 cart-feature mobile-use">
              <div class="discount">
                <a @click="callBonusAndDiscount" v-if="product.price > 0">
                  點數/折價劵折抵
                </a>
              </div>
              <div class="cartlist_del">
                <img :src="require('@/assets/images/icon/trash.svg')" />
                <a href="javascript:;" @click="removeCartItem(index)">移除</a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="sell">
            <div class="row" v-if="product.minusAmount">
              <div class="col-auto mr-auto">
                <p>折抵金額</p>
              </div>
              <div class="col-auto">
                <h4 class="discount-price">-{{ product.minusAmount }}</h4>
              </div>
            </div>
            <div class="row">
              <div class="col-auto mr-auto">
                <p>實付金額</p>
              </div>
              <div class="col-auto">
                <h4>{{ totalPrice | currency }}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cart_listcontent" v-if="isEdit">
      <User
        v-for="(user, i) in product.users"
        v-bind:key="i"
        :index="i"
        :parent-index="index"
        :user="user"
      />
      <!-- 只要是這component擁有的參數被寫在tag上就將會被使用(前者為component的參數，後者為要帶入的參數) -->
    </div>
    <DiscountCoupon :product="product" :bonusData="bonusData" :index="index" :ticketNo.sync="ticketNo" :bonusDescription="bonusDescription"/>
    <BonusPoint :product="product" :bonusData="bonusData" :index="index" :bonusDescription="bonusDescription"/>
    <CanUseCoupon
      :product="product"
      :bonusData="bonusData"
      :index="index"
      :disCoupons="disCoupons"
      :product-dis-coupons-id.sync="disCouponsId"
      :product-coupon-dis.sync="couponDis"
      :product-ticket-no.sync="ticketNo"
      :coupon-info.sync="couponInfo"
    />
    <BalanceEnjoy :product="product"
      :bonusData="bonusData"
      :index="index"/>
    <Denomination :product="product"
      :bonusData="bonusData"
      :index="index"/>

  </div>
</template>

<script>
import _ from 'lodash';
import User from '@/components/cart/partials/User';
import { mapMutations } from 'vuex';
import discountApi from '@/api/discount';
import DiscountCoupon from '@/components/modal/DiscountCoupon/DiscountCoupon';
import BonusPoint from '@/components/modal/BonusPoint/BonusPoint';
import CanUseCoupon from '@/components/modal/CanUseCoupon/CanUseCoupon';
import BalanceEnjoy from '@/components/modal/BalanceEnjoy';
import Denomination from '@/components/modal/Denomination';

export default {
  inject: ['$validator'],
  components: {
    User,
    DiscountCoupon,
    BonusPoint,
    CanUseCoupon,
    BalanceEnjoy,
    Denomination,
  },
  props: {
    index: {
      type: Number,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
    isEdit: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  data() {
    return {
      bonusData: {},
      disCoupons: [],
      disCouponsId: '',
      couponDis: 0,
      ticketNo: null,
      couponInfo: {},
      bonusDescription:'',
    };
  },
  computed: {
    quantity() {
      return _.get(this.product, 'quantity', 0);
    },
    price() {
      return _.get(this.product, 'price', 0);
    },
    minusAmount() {
      return _.get(this.product, 'minusAmount', 0);
    },
    totalPrice() {
      return this.price * this.quantity - this.minusAmount;
    },
  },

  methods: {
    ...mapMutations('cart', ['removeCartItem']),
    callBonusAndDiscount() {
      this.handleDiscount();
      this.searchBonus();
      this.callQueryRedeemHola();
    },
    handleDiscount() {
      discountApi.queryClassInit(
        {
          InitID: this.product.id,
        },
        (res) => {
          if (res.DiscountFlag == '0') {
            this.$bvModal.show('bonus_modal' + this.index);
          } else if (res.DiscountFlag == '1') {
            this.$bvModal.show('discoupon_modal' + this.index);
          } else {
            alert('此課程無法使用折價券');
          }
        }
      );
    },
    searchBonus() {
      discountApi.mmBonusTotal(
        { companyId: 'A0', branchId: this.product.BranchRoomID.slice(0, 4) },
        (res) => (this.bonusData = res)
      );
    },
    callQueryRedeemHola(){
       discountApi.queryRedeemHola(
        {
          CompanyID: 'A0',
          BranchId: this.product.BranchRoomID.slice(0, 4),
          bonusPoints: 9999
        },
        res=>{
          this.bonusDescription=res.DESCRITPION;
          console.log(res)
        }
       )
    }
  },
};
</script>
